module.exports = __webpack_public_path__ + "img/joystick.c40a59d9.svg";